import React from 'react';

import LazyLoader from './LazyLoader';
import RouteContainer from './RouteContainer';
import getRouteQueries from './utils/getRouteQueries';

export default {
    renderRouterContext: function renderRouterContext(child, props) {
        return React.createElement(
            LazyLoader,
            props,
            child
        );
    },

    renderRouteComponent: function renderRouteComponent(child, props) {
        /* eslint-disable react/prop-types */
        let key = props.key;
        let route = props.route;
        /* eslint-enable react/prop-types */

        let routeQueries = getRouteQueries(route, props);
        let queries = key ? routeQueries && routeQueries[key] : routeQueries;

        if (!queries) {
            return child;
        }

        return React.createElement(
            RouteContainer,
            {queries: queries, routerProps: props},
            child
        );
    }
};
